import React from 'react';
import { useTranslation } from 'react-i18next';
import noop from '@wix/da-shared-react/pkg/utils/noop';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { SubNavigation } from '../../../../../types/store';
import { transformPriceRanges } from './helpers';

export interface Props {
  className?: string;
  rangeClassName?: string;
  priceRanges?: SubNavigation;
  minPrice?: number;
  maxPrice?: number;
  setRange?: (minPrice?: number, maxPrice?: number) => void;
}

const ShopFiltersPriceRadioGroup: React.FC<Props> = ({
  className,
  rangeClassName,
  priceRanges: priceRangesSubnav,
  minPrice: currentMinPrice,
  maxPrice: currentMaxPrice,
  setRange = noop,
}) => {
  const { t } = useTranslation();
  // we need to pull min and max from awkward subnav data in order
  // to send it in the form/filters object data
  const priceRanges = transformPriceRanges(priceRangesSubnav);

  return (
    <fieldset
      className={className}
      role="radiogroup"
      aria-labelledby="shop-filters-price"
    >
      <p id="shop-filters-price">
        {t('shopPage.shopFiltersForm.price.legend')}
      </p>

      {Array.isArray(priceRanges) &&
        priceRanges.map(({ label, min_price = 0, max_price = 0 }, i) => {
          const isSelected =
            currentMinPrice === min_price && currentMaxPrice === max_price;
          return (
            <ListItem
              key={`${label}`}
              className={rangeClassName}
              control="radiobutton"
              name="price" // ugh, 1 name, 2 fields
              label={label}
              isSelected={isSelected}
              onChange={() => {
                setRange(min_price, max_price);
              }}
            />
          );
        })}
    </fieldset>
  );
};

ShopFiltersPriceRadioGroup.displayName = 'ShopFiltersPriceRadioGroup';
export default ShopFiltersPriceRadioGroup;
